<template>
  <div class="x-tablelist-view" data-automation="shortMessage">
    <!-- 搜索行 -->
    <ux-searchOption
      :layout="layout"
      :data="filter"
      @search="search"
      @input="search"
    ></ux-searchOption>
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        :total="tableData.totalSize"
        :size.sync="filter.size"
        :page.sync="filter.page"
        @changePage="changePage"
        @changeSize="changeSize"
        :emptyText="$t('HT.nodata')"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      layout: [
        // 搜索项配置
        {
          type: 'input',
          key: 'imei',
          placeholder: this.$t('HT.imeiInput.placeholder')
        }
      ],
      columns: [
        // 表头数据
        {
          label: 'IMEI',
          prop: 'imei',
          tooltip: true,
          render: (h, params) => {
            return h(
              'span',
              {
                class: ['x-table-blue-btn'],
                on: {
                  click: () => {
                    this.$router.push({ name: 'imeiInfo', query: { id: params.id } });
                  }
                }
              },
              params.imei
            );
          }
        },
        {
          label: this.$t('HT.realTimeLog.day'),
          prop: 'day',
          tooltip: true
        },
        {
          label: this.$t('HT.realTimeLog.voltage'),
          prop: 'voltage',
          tooltip: true,
          render: (h, params) => {
            if (!params.voltage) {
              params.voltage = this.$t('HT.realTimeLog.voltage2');
            }
            return h(
              'span',
              {
                class: ['x-table-blue-btn'],
                on: {
                  click: () => {
                    this.$router.push({ name: 'voltageInfo', query: { imei: params.imei } });
                  }
                }
              },
              params.voltage
            );
          }
        },
        {
          label: this.$t('HT.realTimeLog.netLog'),
          prop: 'net_log',
          tooltip: true,
          minWidth: 105,
          render: (h, params) => {
            params.net_log = this.$t('HT.realTimeLog.netLog');
            return h(
              'span',
              {
                class: ['x-table-blue-btn'],
                on: {
                  click: () => {
                    this.$router.push({ name: 'netLogInfo', query: { imei: params.imei } });
                  }
                }
              },
              params.net_log
            );
          }
        },
        {
          label: this.$t('HT.realTimeLog.parameter'),
          prop: 'parameter',
          tooltip: true,
          minWidth: 105,
          render: (h, params) => {
            params.parameter = this.$t('HT.realTimeLog.parameter');
            return h(
              'span',
              {
                class: ['x-table-blue-btn'],
                on: {
                  click: () => {
                    this.$router.push({ name: 'parameterInfo', query: { imei: params.imei } });
                  }
                }
              },
              params.parameter
            );
          }
        },
        {
          label: this.$t('HT.realTimeLog.temperature'),
          prop: 'temperature',
          tooltip: true,
          render: (h, params) => {
            params.temperature = this.$t('HT.realTimeLog.temperature2');
            return h(
              'span',
              {
                class: ['x-table-blue-btn'],
                on: {
                  click: () => {
                    this.$router.push({ name: 'temperatureInfo', query: { imei: params.imei } });
                  }
                }
              },
              params.temperature
            );
          }
        },
        {
          label: this.$t('HT.realTimeLog.activationTime'),
          prop: 'activation_time',
          tooltip: true
        },
        {
          label: this.$t('HT.realTimeLog.todayLogin'),
          prop: 'today_login',
          tooltip: true
        },
        {
          label: this.$t('HT.realTimeLog.version'),
          prop: 'version',
          tooltip: true
        },
        {
          label: this.$t('HT.realTimeLog.lastTime'),
          prop: 'last_time',
          tooltip: true,
          minWidth: 105
        }
      ],
      filter: {
        // 查询参数
        page: 1,
        size: 10
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: [
          // {imei:'1367894 52145632', day:'2020-12-09', voltage:'查看历史电压', net_log:'查看网络日志', parameter:'查看自检参数', temperature:'查看电池温度', activation_time:'2020-12-09 11:00:00', login_num:'3', operate:'qwertyuiop[asdfghjkl;zxcvbnm', last_time:'2020-12-09 10:11:11'}
        ]
      }
    };
  },
  created() {
    this.getList(this.filter);
  },
  methods: {
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList(params) {
      this.$uxLoading.show();
      this.$api.ams.getStatus(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },

    /**
     * 点击搜索
     */
    search() {
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getList(this.filter);
    }
  }
};
</script>
